import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { IMessageEvents } from '../../../constants/events.constants';
import { ViewportService } from '@shared/common/services/viewport/viewport.service';
import { NativeAppService } from '@shared/common/services/native-app/native-app.service';

@Injectable({ providedIn: 'root' })
export class MessageService {
  private readonly overlaySubject = new ReplaySubject<any>(2);
  private readonly languageSubject = new Subject<any>();

  constructor(
    private readonly viewportService: ViewportService,
    private readonly nativeAppService: NativeAppService
  ) {
    this.getOverlayMessage().subscribe((message) => {
      switch (message.text) {
        case IMessageEvents.SHOW_OVERLAY:
          this.nativeAppService.notifyIntentToShowOverlay();
          break;
        case IMessageEvents.HIDE_OVERLAY:
          this.nativeAppService.notifyIntentToHideOverlay();
          break;
        default:
          break;
      }
    });
  }

  sendOverlayMessage(message: string) {
    this.overlaySubject.next({ text: message });
  }

  getOverlayMessage(): Observable<any> {
    return this.overlaySubject.asObservable();
  }

  updateOverlayStatus(headerEvent: boolean, hasOverlay: boolean, isDesktop?: boolean): void {
    const toggleHeaderEvent = headerEvent ? IMessageEvents.HIDE_HEADER : IMessageEvents.SHOW_HEADER;
    const toggleHasOverlay = hasOverlay ? IMessageEvents.SHOW_OVERLAY : IMessageEvents.HIDE_OVERLAY;
    if (this.viewportService.isMobileDevice() || isDesktop) {
      this.sendOverlayMessage(toggleHeaderEvent);
      this.sendOverlayMessage(toggleHasOverlay);
    }
  }

  sendLanguageChange(message: string) {
    this.languageSubject.next({ text: message });
  }
  getLanguageChange(): Observable<any> {
    return this.languageSubject.asObservable();
  }
}
